var _defs, _circle, _path, _g, _rect, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardexpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31690",
    "data-name": "Rectangle 31690",
    width: 45.623,
    height: 27.457,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31688",
    "data-name": "Rectangle 31688",
    width: 45.623,
    height: 14.836,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 29 10"
  }, /*#__PURE__*/React.createElement("image", {
    width: 29,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAKCAYAAABIQFUsAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD0SURBVDhPvZJPSsNQEIffS7RQJLjrJkI37daVBC9RUDyHFHoQQXoWL+CmFJeiG3dtQMim/qOmJk36/R6JJ3hk4Mu8mUC+zCS2rmvTdfxLrbUh6QiUrXqeQoIyjs/KNF1XajgpQslOYdBk1T7EEu5gAxniH4lb6QnNMSQwAtU+pJrsA17gCVb4/uztdGbn93ea7gImTVbtQ7qHDB7hAV6R/gZRFHF2ayhgC9/w5RE9Lwe9gIt2vX3OQzhvsmpf65X0DZ7hHV/RSvXH6jtqrcqqfYU2KPFnklzmy+WiMpIKGgE39Nf2PHMM4dX1jRvQDalLt2HMAUHTce5hxo8iAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Card_expired",
    "data-name": "Card expired",
    transform: "translate(-1043.49 -1149.384)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_418",
    "data-name": "Ellipse 418",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(1043.49 1149.384)",
    fill: "#de6634"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12714",
    "data-name": "Group 12714",
    transform: "translate(1046.802 1161.931)",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38819",
    "data-name": "Path 38819",
    d: "M35.4,23.535H4.3a2.1,2.1,0,0,1-2.1-2.1V2.1A2.1,2.1,0,0,1,4.3,0H35.4a2.1,2.1,0,0,1,2.1,2.1V21.437a2.1,2.1,0,0,1-2.1,2.1",
    transform: "translate(1.377 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12713",
    "data-name": "Group 12713",
    transform: "translate(0 2.224)",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12712",
    "data-name": "Group 12712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12711",
    "data-name": "Group 12711",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12710",
    "data-name": "Group 12710",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12709",
    "data-name": "Group 12709",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31686",
    "data-name": "Rectangle 31686",
    width: 45.623,
    height: 14.818,
    fill: "url(#pattern)"
  }))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31689",
    "data-name": "Rectangle 31689",
    width: 35.314,
    height: 4.633,
    transform: "translate(3.558 5.713)",
    fill: "#1a1818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38820",
    "data-name": "Path 38820",
    d: "M33.058,16.13a8.546,8.546,0,1,1-8.546-8.555,8.551,8.551,0,0,1,8.546,8.555",
    transform: "translate(8.002 2.771)",
    fill: "#e50019"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38821",
    "data-name": "Path 38821",
    d: "M20.147,18.657a.862.862,0,0,1,.867-.912.913.913,0,0,1,0,1.824.861.861,0,0,1-.867-.912m.367-2.106-.206-7.066h1.411l-.206,7.066Z",
    transform: "translate(11.5 4.374)",
    fill: "#fff"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31691",
    "data-name": "Rectangle 31691",
    width: 45.623,
    height: 27.458,
    transform: "translate(1046.802 1161.931)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardexpired);
export default __webpack_public_path__ + "static/media/Card expired.65030c38ba68180beda33467cdc6c062.svg";
export { ForwardRef as ReactComponent };